import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { MentoringPairApiModel } from '@app/api/api-models/program/mentoring/MentoringPairApiModel';
import { MenteeDetailApiModel } from '@app/api/api-models/program/mentoring/MenteeDetailApiModel';
import { MentorDetailApiModel } from '@app/api/api-models/program/mentoring/MentorDetailApiModel';
import { MentoringMatchingFilterSelectorsApiModel } from '@app/api/api-models/program/mentoring/MentoringMatchingFilterSelectorsApiModel';

@Injectable()
export class MtMatchingService extends CrudService<MentoringPairApiModel, string> {
  public apiUrl = 'mentoring-matching';

  public getFilterSelectors(): Observable<MentoringMatchingFilterSelectorsApiModel> {
    return this.http.get<MentoringMatchingFilterSelectorsApiModel>(`${this.apiUrl}/filter-selectors`);
  }

  public getMenteeDetail(programRoleId: string): Observable<MenteeDetailApiModel> {
    return this.http.get<MenteeDetailApiModel>(`${this.apiUrl}/${programRoleId}/mentee-detail`);
  }

  public getMentorsMatches(programRoleId: string): Observable<MentorDetailApiModel[]> {
    return this.http.get<MentorDetailApiModel[]>(`${this.apiUrl}/${programRoleId}/mentor-matches`);
  }
}
